var _rect, _path, _path2, _path3, _g, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#C1C2C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0207 9.03602C15.0859 7.44687 13.6955 5.99822 11.9799 6C10.1691 6.00267 8.91791 7.61583 8.94522 9.05825C8.98223 11.0449 10.4722 12.064 11.8918 12.1201C13.8038 12.1956 15.018 10.7132 15.0207 9.03513V9.03602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60412 15.7949C6.85788 14.8104 7.5205 14.1088 8.22982 13.4481C8.4739 13.2204 8.76203 13.0319 9.05192 12.8665C9.63348 12.5339 10.1895 12.2733 10.9191 12.6086C11.6971 12.9652 12.5518 12.8923 13.344 12.5374C13.7088 12.3738 14.0039 12.4058 14.3678 12.5721C15.6543 13.1617 16.5866 14.1052 17.2527 15.3405C17.3285 15.481 17.4431 15.6975 17.4281 15.8701C17.2557 16.0874 16.6153 16.5698 16.1422 16.8567C15.3941 17.3165 14.5635 17.6079 13.6947 17.8231C12.6803 18.0387 11.7096 18.0466 10.7164 17.9043C10.2327 17.8225 9.72938 17.7071 9.25268 17.5248C8.30213 17.1861 7.56134 16.6945 6.85896 16.1506C6.78351 16.0921 6.67754 15.9854 6.57227 15.9016L6.60412 15.7949Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0198 9.03601C15.0172 10.7132 13.8029 12.1965 11.8909 12.1209C10.4705 12.0649 8.98046 11.0458 8.94434 9.05913C8.9179 7.61671 10.1691 6.00266 11.979 6.00088C13.6946 5.9991 15.085 7.44686 15.0198 9.0369V9.03601Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8740_18242)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_8740_18242",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20C16 17.7909 17.7909 16 20 16C22.2091 16 24 17.7909 24 20C24 22.2091 22.2091 24 20 24C17.7909 24 16 22.2091 16 20Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 20C16 17.7909 17.7909 16 20 16C22.2091 16 24 17.7909 24 20C24 22.2091 22.2091 24 20 24C17.7909 24 16 22.2091 16 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 8,
    height: 8,
    rx: 3,
    fill: "#58975B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23C18.3431 23 17 21.6569 17 20H15C15 22.7614 17.2386 25 20 25V23ZM23 20C23 21.6569 21.6569 23 20 23V25C22.7614 25 25 22.7614 25 20H23ZM20 17C21.6569 17 23 18.3431 23 20H25C25 17.2386 22.7614 15 20 15V17ZM20 15C17.2386 15 15 17.2386 15 20H17C17 18.3431 18.3431 17 20 17V15Z",
    fill: "white",
    mask: "url(#path-3-inside-1_8740_18242)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8740_18242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20C16 17.7909 17.7909 16 20 16C22.2091 16 24 17.7909 24 20C24 22.2091 22.2091 24 20 24C17.7909 24 16 22.2091 16 20Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a6b68e45838131aa07d3fe1dd914c91a.svg";
export { ForwardRef as ReactComponent };